/* ==========================================================================
   nini — MY FAVE IN MOTION
   モーション制御JS (Dawnベース「Master」テーマ用)
   方針:
   - IntersectionObserver + Web Animations API/CSSのみ。外部ライブラリなし
   - 冪等 (再実行しても壊れない)。テーマエディタのsectionイベントで再初期化
   - DOM欠如ページでもエラーゼロ。全処理を try/catch でガード
   - prefers-reduced-motion を実行時にも尊重
   ========================================================================== */
(function () {
  'use strict';

  var NS = '__niniMotion';
  if (window[NS] && window[NS].version >= 3) {
    // 二重読み込み時は既存インスタンスを再初期化して終了 (冪等)
    try { window[NS].initAll(); } catch (e) { /* noop */ }
    return;
  }

  var doc = document;
  var root = doc.documentElement;
  var reducedMotion = false;
  try {
    var mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    reducedMotion = mql.matches;
    var onMqlChange = function (e) { reducedMotion = e.matches; };
    if (mql.addEventListener) mql.addEventListener('change', onMqlChange);
    else if (mql.addListener) mql.addListener(onMqlChange);
  } catch (e) { /* noop */ }

  function motionMode() {
    return root.getAttribute('data-nini-motion') || 'full';
  }
  function motionOff() {
    return motionMode() === 'off' || reducedMotion;
  }

  /* ------------------------------------------------------------------
     1. スクロールリビール
     - 対象は data-nini-reveal。自動付与は AUTO_REVEAL_SELECTORS
     - 1セクション内で 60ms ずつ遅延 (最大 480ms)
     - 一度表示したら再アニメーションしない (unobserve)
  ------------------------------------------------------------------ */
  var AUTO_REVEAL_SELECTORS = [
    // 見出し系 (既存テーマの構造に合わせた控えめな自動対象)
    '.shopify-section .title-wrapper-with-link .title',
    '.shopify-section h2.title:not([data-nini-reveal])',
    // niniカスタムセクションのカード群
    '[id*="__nini-categories"] a[href*="/collections"]',
    '[id*="__featured_collection"] .grid__item',
    '[id*="__nini-club"] [class*="card"]',
    '[id*="__nini-reviews"] [class*="card"], [id*="__nini-reviews"] blockquote',
    '.nini-club-progress',
    // スマホ用ホーム (nini-mobile-home は1セクションに全コンテンツが入っている)
    '[id*="__nini-mobile-home"] h2',
    '[id*="__nini-mobile-home"] .nini-mobile-home__category-card',
    '[id*="__nini-mobile-home"] .nini-mobile-ranking-card'
  ];

  var revealObserver = null;

  function ensureRevealTargets(scope) {
    try {
      var container = scope || doc;
      AUTO_REVEAL_SELECTORS.forEach(function (sel) {
        var nodes;
        try { nodes = container.querySelectorAll(sel); } catch (e) { return; }
        for (var i = 0; i < nodes.length; i++) {
          var el = nodes[i];
          if (!el.hasAttribute('data-nini-reveal')) {
            el.setAttribute('data-nini-reveal', '');
            el.setAttribute('data-nini-reveal-auto', '');
          }
        }
      });
    } catch (e) { /* noop */ }
  }

  function applyStagger() {
    try {
      var sections = doc.querySelectorAll('.shopify-section');
      for (var s = 0; s < sections.length; s++) {
        var items = sections[s].querySelectorAll('[data-nini-reveal]:not(.nini-in)');
        for (var i = 0; i < items.length; i++) {
          var delay = Math.min(i * 60, 480);
          items[i].style.setProperty('--nini-reveal-delay', delay + 'ms');
        }
      }
    } catch (e) { /* noop */ }
  }

  function initReveal() {
    try {
      if (!('IntersectionObserver' in window)) {
        // フォールバック: 全て即時表示
        markAllRevealed();
        return;
      }
      if (motionOff()) { markAllRevealed(); return; }

      ensureRevealTargets();
      applyStagger();

      if (revealObserver) revealObserver.disconnect();
      revealObserver = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('nini-in');
            revealObserver.unobserve(entries[i].target);
          }
        }
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

      var targets = doc.querySelectorAll('[data-nini-reveal]:not(.nini-in)');
      for (var t = 0; t < targets.length; t++) {
        var rect = targets[t].getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          // 既に画面内: 即時表示 (初期表示をブロックしない)
          targets[t].classList.add('nini-in');
        } else {
          revealObserver.observe(targets[t]);
        }
      }
    } catch (e) {
      markAllRevealed();
    }
  }

  function markAllRevealed() {
    try {
      var targets = doc.querySelectorAll('[data-nini-reveal]');
      for (var i = 0; i < targets.length; i++) targets[i].classList.add('nini-in');
    } catch (e) { /* noop */ }
  }

  /* ------------------------------------------------------------------
     2. ヒーロー ブランドリビール
     - [data-nini-hero] 内の [data-nini-hero-item] を段階表示
     - sessionStorage で 1セッション1回のみ
  ------------------------------------------------------------------ */
  function initHero() {
    try {
      // PC用(nini-hero)とスマホ用(nini-mobile-home)の両方に対応
      var heroes = doc.querySelectorAll('[data-nini-hero]');
      if (!heroes.length || motionOff()) return;

      var seen = false;
      try { seen = sessionStorage.getItem('nini-hero-played') === '1'; } catch (e) { /* noop */ }
      if (seen) return;

      var total = 0;
      for (var h = 0; h < heroes.length; h++) {
        var items = heroes[h].querySelectorAll('[data-nini-hero-item]');
        for (var i = 0; i < items.length; i++) {
          items[i].style.setProperty('--nini-hero-index', String(i));
          total++;
        }
      }
      if (!total) return;
      root.classList.add('nini-hero-armed');
      // 2フレーム後に再生 (初期描画を待つ / LCP要素は対象外にすること)
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('nini-hero-play');
          try { sessionStorage.setItem('nini-hero-played', '1'); } catch (e) { /* noop */ }
          window.setTimeout(function () {
            root.classList.remove('nini-hero-armed', 'nini-hero-play');
          }, 2500);
        });
      });
    } catch (e) { /* noop */ }
  }

  /* ------------------------------------------------------------------
     3. カート追加フィードバック
     - Dawnの pub/sub (cart-update) があれば購読、無ければ fetch フック
     - 成功時: ボタン文言変更+チェック、カートアイコンをポップ、aria-live通知
     - エラー時は成功演出を出さない
  ------------------------------------------------------------------ */
  var atcBound = false;
  var lastAtcButton = null;

  function bindAtcButtons() {
    try {
      var forms = doc.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].getAttribute('data-nini-atc-bound') === '1') continue;
        forms[i].setAttribute('data-nini-atc-bound', '1');
        forms[i].addEventListener('submit', function (e) {
          try {
            var btn = e.target.querySelector('button[type="submit"], [name="add"]');
            if (btn) lastAtcButton = btn;
          } catch (err) { /* noop */ }
        }, true);
      }
    } catch (e) { /* noop */ }
  }

  function ensureLiveRegion() {
    var region = doc.getElementById('nini-atc-live');
    if (!region) {
      region = doc.createElement('div');
      region.id = 'nini-atc-live';
      region.className = 'nini-visually-hidden';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('role', 'status');
      doc.body.appendChild(region);
    }
    return region;
  }

  function onCartAdded() {
    try {
      // aria-live (動きだけに依存しない通知)
      ensureLiveRegion().textContent = 'カートに商品を追加しました';

      // カートアイコン ポップ
      var icon = doc.querySelector('#cart-icon-bubble, [href="/cart"], a[href*="/cart"]');
      if (icon && !motionOff()) {
        icon.classList.remove('nini-cart-pop');
        void icon.offsetWidth; // reflow で再生し直し
        icon.classList.add('nini-cart-pop');
        window.setTimeout(function () { icon.classList.remove('nini-cart-pop'); }, 600);
      }

      // ボタン文言 (reduced motion でも文言・アイコンは変更してよい)
      var btn = lastAtcButton;
      if (btn && !btn.getAttribute('data-nini-atc-busy')) {
        btn.setAttribute('data-nini-atc-busy', '1');
        var original = btn.innerHTML;
        btn.classList.add('nini-atc-success');
        btn.innerHTML =
          '<span class="nini-atc-label">' +
          '<svg class="nini-atc-check' + (motionOff() ? ' nini-atc-check--static' : '') + '" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
          '<path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '追加しました</span>';
        window.setTimeout(function () {
          try {
            btn.innerHTML = original;
            btn.classList.remove('nini-atc-success');
            btn.removeAttribute('data-nini-atc-busy');
          } catch (e) { /* noop */ }
        }, 1600);
      }
      lastAtcButton = null;
    } catch (e) { /* noop */ }
  }

  function initAtcFeedback() {
    bindAtcButtons();
    if (atcBound) return;
    atcBound = true;

    // Dawn の pub/sub があれば利用
    try {
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (payload) {
          try {
            // product-form からの追加のみ対象 (数量変更等は除外)
            if (payload && payload.source === 'product-form') onCartAdded();
          } catch (e) { /* noop */ }
        });
        return;
      }
    } catch (e) { /* noop */ }

    // フォールバック: fetch を軽くフック (add.js 成功時のみ)
    try {
      var origFetch = window.fetch;
      if (typeof origFetch === 'function' && !origFetch.__niniWrapped) {
        var wrapped = function (input, init) {
          var url = (typeof input === 'string') ? input : (input && input.url) || '';
          var p = origFetch.apply(this, arguments);
          if (url.indexOf('/cart/add') !== -1) {
            p.then(function (res) {
              if (res && res.ok) onCartAdded();
            }).catch(function () { /* エラー時は何もしない */ });
          }
          return p;
        };
        wrapped.__niniWrapped = true;
        window.fetch = wrapped;
      }
    } catch (e) { /* noop */ }
  }

  /* ------------------------------------------------------------------
     4. ティッカー (sections/nini-ticker.liquid)
     - 停止ボタン、キーボードフォーカスで停止はCSS側
     - ここでは停止ボタンのトグルのみ
  ------------------------------------------------------------------ */
  function initTickers(scope) {
    try {
      var tickers = (scope || doc).querySelectorAll('.nini-ticker');
      for (var i = 0; i < tickers.length; i++) {
        (function (ticker) {
          if (ticker.getAttribute('data-nini-ticker-bound') === '1') return;
          ticker.setAttribute('data-nini-ticker-bound', '1');
          var btn = ticker.querySelector('.nini-ticker__pause');
          if (!btn) return;
          btn.addEventListener('click', function () {
            var paused = ticker.getAttribute('data-paused') === 'true';
            ticker.setAttribute('data-paused', paused ? 'false' : 'true');
            btn.setAttribute('aria-pressed', paused ? 'false' : 'true');
            btn.setAttribute('aria-label', paused ? 'お知らせの流れる表示を停止' : 'お知らせの流れる表示を再生');
          });
        })(tickers[i]);
      }
    } catch (e) { /* noop */ }
  }

  /* ------------------------------------------------------------------
     5. nini Club 進捗バー: IO は reveal と共通 (.nini-club-progress に data-nini-reveal 付与済み)
  ------------------------------------------------------------------ */

  /* ------------------------------------------------------------------
     6. CUTE PACK: お気に入りハートバースト
     - [data-nini-favorite] / [data-nini-favorites-heart] クリックで
       「お気に入りON」に変わった時だけ、小さなハート5個を放出
     - ヘッダーのお気に入りアイコンをポップ
     - reduced-motion / モードoff / cute=false では何もしない
  ------------------------------------------------------------------ */
  var cuteBound = false;
  var HEART_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M12 21s-6.7-4.3-9.3-8.2C.8 9.9 2 6.6 4.9 5.6c1.8-.6 3.8 0 5.1 1.5L12 9l2-1.9c1.3-1.5 3.3-2.1 5.1-1.5 2.9 1 4.1 4.3 2.2 7.2C18.7 16.7 12 21 12 21z"/></svg>';

  function cuteOn() {
    return root.getAttribute('data-nini-cute') === 'true' && !motionOff();
  }

  function spawnHeartBurst(btn) {
    try {
      if (!cuteOn() || !btn || !btn.getBoundingClientRect) return;
      var rect = btn.getBoundingClientRect();
      if (!rect.width && !rect.height) return;

      var wrap = doc.createElement('span');
      wrap.className = 'nini-heart-burst';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.style.left = Math.round(rect.left + rect.width / 2) + 'px';
      wrap.style.top = Math.round(rect.top + rect.height / 2) + 'px';

      for (var i = 0; i < 5; i++) {
        var s = doc.createElement('span');
        s.innerHTML = HEART_SVG;
        var ang = (-90 + (i - 2) * 32) * Math.PI / 180;
        var dist = 24 + (i % 2) * 10;
        s.style.setProperty('--nini-burst-x', Math.round(Math.cos(ang) * dist) + 'px');
        s.style.setProperty('--nini-burst-y', Math.round(Math.sin(ang) * dist) + 'px');
        s.style.setProperty('--nini-burst-delay', (i * 30) + 'ms');
        wrap.appendChild(s);
      }

      doc.body.appendChild(wrap);
      window.setTimeout(function () {
        try { wrap.remove(); } catch (e) { /* noop */ }
      }, 900);

      // ヘッダーのお気に入りアイコンをポップ
      var icon = doc.querySelector('.header__icon--wishlist');
      if (icon) {
        icon.classList.remove('nini-cart-pop');
        void icon.offsetWidth;
        icon.classList.add('nini-cart-pop');
        window.setTimeout(function () { icon.classList.remove('nini-cart-pop'); }, 600);
      }
    } catch (e) { /* noop */ }
  }

  function isFavorited(btn) {
    return btn.getAttribute('aria-pressed') === 'true' || btn.classList.contains('is-favorite');
  }

  function initCute() {
    if (cuteBound) return;
    cuteBound = true;
    // capture フェーズで購読: 既存のお気に入りJSが stopPropagation しても検知できる
    // (実機検証で bubble フェーズでは発火しないことを確認済み)
    doc.addEventListener('click', function (e) {
      try {
        if (!e.target || !e.target.closest) return;
        var btn = e.target.closest('[data-nini-favorite], [data-nini-favorites-heart], .nini-favorite-button');
        if (!btn) return;
        var before = isFavorited(btn);
        // お気に入り処理(既存JS)の完了を待ってから状態を判定
        window.setTimeout(function () {
          try {
            if (isFavorited(btn) && !before) spawnHeartBurst(btn);
          } catch (err) { /* noop */ }
        }, 80);
      } catch (err) { /* noop */ }
    }, true);
  }

  /* ------------------------------------------------------------------
     初期化・テーマエディタ対応
  ------------------------------------------------------------------ */
  function initAll(scope) {
    root.classList.add('nini-motion-ready');
    initReveal();
    initHero();
    initAtcFeedback();
    initTickers(scope);
    initCute();
  }

  function destroy() {
    try { if (revealObserver) revealObserver.disconnect(); } catch (e) { /* noop */ }
  }

  window[NS] = { version: 3, initAll: initAll, destroy: destroy };

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // テーマエディタ: セクション追加/再描画/並び替えに追随
  if (window.Shopify && window.Shopify.designMode) {
    doc.addEventListener('shopify:section:load', function (e) {
      try { ensureRevealTargets(e.target); initAll(e.target); } catch (err) { /* noop */ }
    });
    doc.addEventListener('shopify:section:reorder', function () {
      try { initReveal(); } catch (err) { /* noop */ }
    });
    doc.addEventListener('shopify:section:unload', function () {
      try { initReveal(); } catch (err) { /* noop */ }
    });
  }
})();
